import ContractsCargoTaxiAddRequest, {
  ContractsCargoTaxiAddRequestBody,
} from "./contracts-cargo-taxi-add.request";

const createBody = (
  request: ContractsCargoTaxiAddRequest,
): ContractsCargoTaxiAddRequestBody => {
  return {
    allowChargeDuringRide: request.allowChargeDuringRide,
    allowChargeWhileApproaching: request.allowChargeWhileApproaching,
    allowChargeWhileReturning: request.allowChargeWhileReturning,
    cargoCompanyId: request.cargoCompanyId,
    disabled: request.disabled,
    discountLimit: request.discountLimit,
    distanceRate: request.distanceRate,
    haltingTimeAfterMinutes: request.haltingTimeAfterMinutes,
    haltingTimeRate: request.haltingTimeRate,
    model: request.model,
    publishingAllowed: request.publishingAllowed,
    taxiCorporationId: request.taxiCorporationId,
    validSince: request.validSince,
    validTo: request.validTo,
    contactPassengerAfterMinutes: request.contactPassengerAfterMinutes,
    cancelByTaxiAllowed: request.cancelOrderByTaxiAllowed,
    editByTaxiAllowed: request.editOrderByTaxiAllowed,
    autoApprovalMinDistance: request.autoApprovalMinDistance,
    autoApprovalSwitch: request.autoApprovalSwitch,
    autoApprovalMinTime: request.autoApprovalMinTime,
    approvalDeadlineSwitch: request.approvalDeadlineSwitch,
    approvalDeadlineTime: request.approvalDeadlineTime,
  };
};

const contractsCargoTaxiAddRequestFactory = {
  createBody,
};

export default contractsCargoTaxiAddRequestFactory;
